import { PlanSection } from "./PlanSection";
import { CreditsSection } from "./CreditsSection";
import { PaymentHistorySection } from "./paymentHistory";
import { CreditHistorySection } from "./CreditHistorySection";
import type { MembershipData } from "../../types/membership";

interface MembershipDashboardProps {
  data: MembershipData;
}

export function MembershipDashboard({ data }: MembershipDashboardProps) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
      <div className="lg:col-span-2 space-y-4 md:space-y-6 lg:space-y-8 order-2 lg:order-1">
        <PlanSection plan={data.active_membership} />
        <CreditHistorySection />
        <PaymentHistorySection payments={data.payments} />
      </div>

      <div className="lg:col-span-1 order-1 lg:order-2">
        <CreditsSection credits={data.details} nextRenewalDate={data.active_membership?.payment_ends_at || ""} />
      </div>
    </div>
  );
}
